import { render } from "./CollectionsEdit.vue?vue&type=template&id=5842fcbc&scoped=true"
import script from "./CollectionsEdit.vue?vue&type=script&lang=js"
export * from "./CollectionsEdit.vue?vue&type=script&lang=js"

import "./CollectionsEdit.vue?vue&type=style&index=0&id=5842fcbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5842fcbc"]])

export default __exports__